import {Table} from '@mantine/core';
import classes from './table.module.css';

export const TableTheme = Table.extend({
  classNames: classes,
});